import Cookies from 'js-cookie';

export const DEVICE_VERIFY_COOKIE_NAME = 'device-verify';

export function setDeviceVerifyCookie(token: string) {
  const afterOneHour = new Date(Date.now() + 60 * 60 * 1000);
  Cookies.set(DEVICE_VERIFY_COOKIE_NAME, token, {
    expires: afterOneHour,
    path: '/',
  });
}

export function getDeviceVerifyCookie() {
  return Cookies.get(DEVICE_VERIFY_COOKIE_NAME);
}

export function removeDeviceVerifyCookie() {
  Cookies.remove(DEVICE_VERIFY_COOKIE_NAME, {
    path: '/',
  });
}
